// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import { Select } from 'antd';
import React, { useState } from 'react';

// USER COMPONENTS
import CountryCode from '../utils/countryCode.json';

const CountryCodePicker = ({ form, width, container }) => {
  const [countries, setCountries] = useState(CountryCode);

  return (
    <Select
      style={{ minWidth: width ?? 150 }}
      showSearch
      placeholder="Code"
      defaultValue={form.getFieldValue('code')}
      onChange={value => form.setFieldsValue({ code: value })}
      optionFilterProp="children"
      filterOption={(input, option) => option.key.toLowerCase().includes(input.toLowerCase())}
      getPopupContainer={() => document.getElementById(container)}
    >
      {countries?.map(country => (
        <Select.Option value={country?.dial_code} key={`${country?.name}${country?.dial_code}`}>
          {country?.name}({country?.dial_code})
        </Select.Option>
      ))}
    </Select>
  );
};

export default CountryCodePicker;
